import { enumElementLayer } from "../constants";
import { XML_ConvertDPI } from "./XML_ConvertDPI";

export function XML_GetDX(drawElement, layer) {
  if (layer === -1 || layer === enumElementLayer.master) return 0;

  return XML_ConvertDPI(drawElement["dx"]); //
}
